module.exports = __webpack_public_path__ + "static/media/ocean_bg.2dcdc200.jpg";